import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import { CustomRadioGroupProps } from "./radio-button-component.props";
const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  label,
  name,
  value,
  options,
  row = false,
  onChange,
}) => {
  return (
    <FormControl component="fieldset">
      {label && (
        <Box sx={{ mt: 3 }}>
          <FormLabel
            component="legend"
            sx={{
              fontWeight: 600,
              fontSize: "1.1rem",
              mb: 2, // margin-bottom
              color: "#000",
              "&.Mui-focused": {
                color: "#000",
              },
            }}
          >
            {label}
          </FormLabel>
        </Box>
      )}
      <RadioGroup row={row} name={name} value={value} onChange={onChange}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CustomRadioGroup;
